//For adding user-readable strings to start step buttons, this map had to be made to translate mongo data about stepType.
// and yes, some are more complicated than String.toLowerCase().

const stepTypeStrings = {
  PERSONALITY_QUIZ: 'Quiz',
  LISTICLE: 'Listicle',
  REFERRAL: 'Referral',
  LEAD_GEN: 'Lead Gen',
  TEXT_TRIVIA: 'Trivia',
  FILTERING: 'Filtering',
  VIDEO: 'Video',
  REVIEW: 'Review',
  STORE_FINDER: 'Store Finder',
  PINTEREST: 'Pinterest',
  CHECKLIST: 'Checklist',
  MEMORY_MATCH: 'Memory Match',
  POLL: 'Poll',
  PUZZLE: 'Puzzle',
  ARTICLE: 'Article',
}
const getStepName = function (type) {
  return stepTypeStrings[type] || 'Step'
}
export default getStepName
